// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_DesvincularComboInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/desvincular_combo/{item_id}
 *
 * Tira o combo do item (NS 2026-0090): libera a reserva e devolve o preco de
 * matriz. No body — the item id arrives as a URL path segment.
 */
import { registerContract } from './validate'

export interface Orders_DesvincularComboInput {}

registerContract('Orders_DesvincularComboInput', {})
